// extracted by mini-css-extract-plugin
export default {"paymentSummaryContainer":"PaymentSummary_paymentSummaryContainer__ZMKnW"};